import React, { useMemo, useContext } from 'react';
import GracePeriodContext from '../grace_period_context';
import { Link } from '../../shared/ui/navigations/link';

const TrialDaysIndicator: React.FC = () => {
  const { gracePeriod } = useContext(GracePeriodContext);
  const styles = useMemo(() => getStyles(), []);

  if (!gracePeriod || !gracePeriod.trial) return null;

  const label = (() => {
    if (gracePeriod.days_left > 0) {
      return (
        <>
          <span style={styles.label}>無料トライアル終了まで</span>
          <span style={styles.days}>{`あと${gracePeriod.days_left}日`}</span>
        </>
      );
    }
    if (gracePeriod.days_left === 0) {
      return (
        <>
          <span style={styles.label}>無料トライアル</span>
          <span style={styles.days}>本日終了</span>
        </>
      );
    }
    return <span style={styles.days}>無料トライアル期間終了</span>;
  })();

  return (
    <Link className="expenses-trial-days-indicator" style={styles.indicator} href="/aiexpense/organization/plans">
      {label}
    </Link>
  );
};

const getStyles = () => ({
  indicator: {
    display: 'inline-flex' as const,
    alignItems: 'center' as const,
    gap: '6px',
    fontSize: '1.2rem',
    textDecoration: 'none' as const,
    whiteSpace: 'nowrap' as const
  },
  label: {
    color: '#666'
  },
  days: {
    fontWeight: 'bold' as const,
    color: '#c84b1a'
  }
});

export default TrialDaysIndicator;
